import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, Inject, OnDestroy, OnInit, Optional, inject } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, firstValueFrom } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { AuthService } from 'src/app/auth.service';
import { ShareMenuDialogComponent } from 'src/app/shared/components/share-menu-dialog/share-menu-dialog.component';
import { AddSectionComponent } from 'src/app/shared/services/add-section/add-section.component';
import { AppConfirmService } from 'src/app/shared/services/app-confirm/app-confirm.service';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { PathService } from '../path.service';

@Component({
  selector: 'app-path-list',
  templateUrl: './path-list.component.html',
  styleUrls: ['./path-list.component.scss', '../../../questions/questions.component.scss'],
  standalone: false,
})
export class PathListComponent implements OnInit, OnDestroy {
  private sidenavService = inject(SidenavService);

  isSmallSceen = this.sidenavService.isSmallOrTablet;
  searchTerm = '';
  pageIndex = 0;
  pageSizeOptions = [10, 20, 30, 40, 50];
  pageSizeDialogOptions = [5, 10, 20, 30, 40, 50];
  pageSize = this.dialogData?.id ? this.pageSizeDialogOptions[0] : this.pageSizeOptions[0];
  totalSize = 0;
  loading = false;
  pathList = [];
  pathEventSubscription: Subscription;
  pathButton;
  below700;
  userID;

  constructor(
    private appService: AppService,
    private pathService: PathService,
    private dialog: MatDialog,
    private confirm: AppConfirmService,
    private toast: ToastService,
    private translate: TranslateService,
    private breakpointObserver: BreakpointObserver,
    private bottomSheet: MatBottomSheet,
    private authService: AuthService,
    @Optional() @Inject(MAT_DIALOG_DATA) private dialogData: any,
    @Optional() private dialogRef: MatDialogRef<PathListComponent>,
    private router: Router
  ) {
    this.pathEventSubscription = this.pathService.pathEvent$.subscribe((res) => {
      this.getPaths();
    });
  }

  async ngOnInit() {
    this.userID = ((await this.authService.getUserData()) as any).id;
  }
  ngOnDestroy() {
    this.pathEventSubscription.unsubscribe();
  }
  onPageChange(event) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.page;
    this.getPaths();
  }
  filter() {
    this.getPaths();
  }
  getPaths() {
    this.pathService.getPaths(this.pageSize, this.pageIndex, this.searchTerm).subscribe({
      next: (output) => {
        this.pathList = output.result.map((element) => {
          element.buttons = [
            {
              name: 'Global.Edit',
              func: (data) => {
                this.editPath(element);
              },
              data: {},
            },
            {
              name: 'Global.Share',
              func: (data) => {
                this.sharePath(element);
              },
              data: {},
            },
            {
              name: 'Global.Delete',
              func: (data) => {
                this.deletePath(element);
              },
              data: {},
            },
          ];
          return element;
        });
        this.totalSize = output.count;
      },
      error: (error) => {
        console.error(error);
      },
    });
  }
  editPath(path) {
    this.dialog.open(AddSectionComponent, {
      data: { type: 'edit-path', ...path },
      width: '500px',
    });
  }
  sharePath(path) {
    this.openShareMenu(path._id);
  }

  openShareMenu(pathID) {
    const isSmallScreen = this.breakpointObserver.isMatched('(max-width: 599px)');

    if (isSmallScreen) {
      this.bottomSheet.open(ShareMenuDialogComponent, {
        data: {
          pathID,
        },
      });
    } else {
      this.dialog.open(ShareMenuDialogComponent, {
        width: '500px',
        maxHeight: '80vh',
        data: {
          pathID,
        },
      });
    }
  }
  async deletePath(path) {
    const response = await firstValueFrom(this.confirm.confirm());
    if (response) {
      this.pathService.deletePath(path).subscribe({
        next: (value) => {
          this.getPaths();
          this.toast.snackbar.open(this.translate.instant('Snackbar.Done'), 'Ok', {
            duration: 2000,
          });
        },
        error: (error) => {
          console.error(error);
        },
      });
    }
  }
  navigate(path) {
    this.router.navigate(['path', 'view', path._id]);
  }
  isDialog() {
    return !!this.dialogData?.id;
  }
  choosePath(path) {
    this.dialogRef.close(path);
  }
  alreadyInPath(path) {
    const foundElement = path.content.find((element) => element.id == this.dialogData?.id);
    return !!foundElement;
  }
}
